@for (message of displayBroadcastMessages; track message) {
  <div class="ontario-margin-bottom-24-! broadcast-message">
    <app-alert-banner bannerType="warning" [bannerText]="message"> </app-alert-banner>
  </div>
}

<div class="safety-preventioin-hero">
  <h1>{{'SafetyAndPrevention.PageTitle' + pagepath | translate}}</h1>
  <div class="text">{{'SafetyAndPrevention.PageText' + pagepath | translate}}</div>
  @if (pagepath=='Home') {
    <div class="links">
      <button [routerLink]="getUrl('/safety-and-prevention/training-providers')">{{'Tab.TrainingProviders' |
      translate}}</button>
      <button [routerLink]="getUrl('/safety-and-prevention/learners')">{{'Tab.Learners' | translate}}</button>
      <button [routerLink]="getUrl('/safety-and-prevention/employers')">{{'Tab.Employers' | translate}}</button>
    </div>
  }
</div>
<div class="public-page-with-right-sidebar ontario-row">
  <div class="main-content">
    @if (pagepath=='TrainingProviders') {
      <section class="section-line notop-padding">
        <h2>{{'SafetyAndPrevention.ApplyBecomeTP' | translate}}</h2>
        <div class="text">{{'SafetyAndPrevention.BecomeTPText' | translate}}</div>
        <div class="list-links" role="list">
          <div role="listitem"><img src="assets/images/checkmark-black.svg"
          alt="" />{{'SafetyAndPrevention.BecomeTPPoint1' | translate}}</div>
          <div role="listitem"><img src="assets/images/checkmark-black.svg"
          alt="" />{{'SafetyAndPrevention.BecomeTPPoint2' | translate}}</div>
          <div role="listitem"><img src="assets/images/checkmark-black.svg"
          alt="" />{{'SafetyAndPrevention.BecomeTPPoint3' | translate}}</div>
          <div role="listitem"><img src="assets/images/checkmark-black.svg"
          alt="" />{{'SafetyAndPrevention.BecomeTPPoint4' | translate}}</div>
          <div role="listitem"><img src="assets/images/checkmark-black.svg"
          alt="" />{{'SafetyAndPrevention.BecomeTPPoint5' | translate}}</div>
          <div role="listitem"><img src="assets/images/checkmark-black.svg"
          alt="" />{{'SafetyAndPrevention.BecomeTPPoint6' | translate}}</div>
          <div role="listitem"><img src="assets/images/checkmark-black.svg"
          alt="" />{{'SafetyAndPrevention.BecomeTPPoint7' | translate}}</div>
        </div>
        <div>
          <div class="tp-steps-info">{{'SafetyAndPrevention.StepsObtainTPAccess' | translate}}</div>
          <div>
            <div [innerHtml]="getHtml('SafetyAndPrevention.Step1CreatePSAccount'|translate )"></div>
            <div [innerHtml]="getHtml('SafetyAndPrevention.Step2TPOnboardingProcess'|translate )"></div>
          </div>
        </div>
        <div><button (click)="goToLogin(TPUtil.UserTypeTrainingProvider)"
        class="nomargin">{{'SafetyAndPrevention.BecomeeAnTP' | translate}}</button></div>
      </section>
    }

    @if (pagepath=='Employers') {
      <section class="section-line notop-padding">
        <h2>{{'SafetyAndPrevention.GainAccessToTheEmployerPortal' | translate}}</h2>
        <div class="text">{{'SafetyAndPrevention.GainAccessToEPText' | translate}}</div>
        <div class="list-links-accessible" role="list">
          <div role="listitem"><img src="assets/images/checkmark-black.svg" alt=""/>{{'SafetyAndPrevention.GainAccessToEPPoint1' | translate}}
          </div>
          <div role="listitem"><img src="assets/images/checkmark-black.svg"  alt=""/>{{'SafetyAndPrevention.GainAccessToEPPoint2' | translate}}
          </div>
          <div role="listitem"><img src="assets/images/checkmark-black.svg" alt=""/>{{'SafetyAndPrevention.GainAccessToEPPoint3' | translate}}
          </div>
        </div>
        <div>
          <div class="ontario-margin-bottom-12-!">{{'SafetyAndPrevention.StepsToObtainEmployerPortalAccess' | translate}}:
          </div>
          <div><b>{{'SafetyAndPrevention.Steps1' | translate}}</b>{{'SafetyAndPrevention.Steps1Desc' | translate}}</div>
          <div><b>{{'SafetyAndPrevention.Steps2' | translate}}</b>{{'SafetyAndPrevention.Steps2Desc' | translate}}</div>
        </div>
        <div><button (click)="goToLogin(TPUtil.UserTypeEmployer)" type="button"
          class="nomargin gain-employer-portal-access-button">{{'SafetyAndPrevention.GainEmployerPortalAccess' |
        translate}}</button></div>
      </section>
    }

    <section class="section-line notop-padding" [class.notop-padding]="pagepath!='TrainingProviders'">
      <h2>{{'SafetyAndPrevention.CPOApprovedTrainingPrograms' | translate}}</h2>
      <h3>{{'SafetyAndPrevention.WAHTraining' | translate}}</h3>
      <div class="text">{{'SafetyAndPrevention.WAHTrainingText' | translate}}</div>
      <div class="list-links">
        <div class="links">
          @if (pagepath=='TrainingProviders' && currentLang == 'en') {
            <a
              href="https://www.ontario.ca/page/provider-standard-working-heights-training" target="_blank"
            rel="noopener">{{'SafetyAndPrevention.ReadProviderStandard' | translate}}</a>
          }
          @if (pagepath=='TrainingProviders' && currentLang == 'fr') {
            <a
              href="https://www.ontario.ca/fr/page/norme-concernant-les-fournisseurs-de-formation-pour-le-travail-en-hauteur"
            target="_blank" rel="noopener">{{'SafetyAndPrevention.ReadProviderStandard' | translate}}</a>
          }
        </div>
        <div class="links">
          @if (pagepath!='TrainingProviders') {
            <button
              [routerLink]="getUrl('/safety-and-prevention/cpo-approved-courses')">
              {{'SafetyAndPrevention.FindAvailableCourses' | translate}}
            </button>
          }
          @if (currentLang == 'en') {
            <a href="https://www.ontario.ca/page/program-standard-working-heights-training"
            target="_blank" rel="noopener">{{'SafetyAndPrevention.ReadProgramStandard' | translate}}</a>
          }
          @if (currentLang == 'fr') {
            <a
              href="https://www.ontario.ca/fr/page/norme-concernant-le-programme-de-formation-pour-le-travail-en-hauteur"
            target="_blank" rel="noopener">{{'SafetyAndPrevention.ReadProgramStandard' | translate}}</a>
          }
        </div>
      </div>
    </section>

    <section class="section-line">
      <h3>{{'SafetyAndPrevention.JHSCTraining' | translate}}</h3>
      <div class="text">{{'SafetyAndPrevention.JHSCTrainingText' | translate}}</div>
      <div class="list-links">
        <div class="links">
          @if (pagepath=='TrainingProviders' && currentLang == 'en') {
            <a
              href="https://www.ontario.ca/page/provider-standard-joint-health-and-safety-committee-training"
            target="_blank" rel="noopener">{{'SafetyAndPrevention.ReadProviderStandard' | translate}}</a>
          }
          @if (pagepath=='TrainingProviders' && currentLang == 'fr') {
            <a
              href="https://www.ontario.ca/fr/page/norme-concernant-les-fournisseurs-de-formation-des-comites-mixtes-de-sante-et-securite"
            target="_blank" rel="noopener">{{'SafetyAndPrevention.ReadProviderStandard' | translate}}</a>
          }
        </div>
        <div class="links">
          @if (pagepath!='TrainingProviders') {
            <button
              [routerLink]="getUrl('/safety-and-prevention/cpo-approved-courses')">
              {{'SafetyAndPrevention.FindAvailableCourses' | translate}}
            </button>
          }
          @if (currentLang == 'en') {
            <a
              href="https://www.ontario.ca/page/program-standard-joint-health-and-safety-committee-training"
            target="_blank" rel="noopener">{{'SafetyAndPrevention.ReadProgramStandard' | translate}}</a>
          }
          @if (currentLang == 'fr') {
            <a
              href="https://www.ontario.ca/fr/page/norme-concernant-les-programmes-de-formation-des-comites-mixtes-de-sante-et-securite"
            target="_blank" rel="noopener">{{'SafetyAndPrevention.ReadProgramStandard' | translate}}</a>
          }
        </div>
      </div>
    </section>

    @if (pagepath!='Learners') {
      <section>
        <h3>{{'SafetyAndPrevention.SupportingOntarioSafeEmployersProgram' | translate}}</h3>
        <div class="text">{{'SafetyAndPrevention.SupportingOntarioSafeEmployersProgramText' | translate}}</div>
        <div>
          @if (currentLang == 'en') {
            <a href="https://www.ontario.ca/page/supporting-ontarios-safe-employers-program"
            target="_blank" rel="noopener">{{'SafetyAndPrevention.SupportingOntarioSafeEmployersProgram' | translate}}</a>
          }
          @if (currentLang == 'fr') {
            <a
              href="https://www.ontario.ca/fr/page/reconnaissance-des-employeurs-pour-la-securite-au-travail-en-ontario"
            target="_blank" rel="noopener">{{'SafetyAndPrevention.SupportingOntarioSafeEmployersProgram' | translate}}</a>
          }
        </div>
      </section>
    }

    @if (pagepath=='Learners') {
      <section class="section-line">
        <h2>{{'SafetyAndPrevention.RegisterLearnerPortalAccount' | translate}}</h2>
        <div class="text">
          {{'SafetyAndPrevention.RegisterLearnerText' | translate}}
        </div>
        <div class="list-links" role="list">
          <div role="listitem"><img src="assets/images/checkmark-black.svg"
          alt="" />{{'SafetyAndPrevention.RegisterLearnerPoint1' | translate}}</div>
          <div role="listitem"><img src="assets/images/checkmark-black.svg"
          alt="" />{{'SafetyAndPrevention.RegisterLearnerPoint2' | translate}}</div>
          <div role="listitem"><img src="assets/images/checkmark-black.svg"
          alt="" />{{'SafetyAndPrevention.RegisterLearnerPoint3' | translate}}</div>
          <div role="listitem"><img src="assets/images/checkmark-black.svg"
          alt="" />{{'SafetyAndPrevention.RegisterLearnerPoint4' | translate}}</div>
          <div role="listitem"><img src="assets/images/checkmark-black.svg"
          alt="" />{{'SafetyAndPrevention.RegisterLearnerPoint5' | translate}}</div>
        </div>
        <div class="links"><button
          (click)="goToLogin(TPUtil.UserTypeLearner)">{{'SafetyAndPrevention.RegisterForLearnerPortal' |
        translate}}</button></div>
      </section>
    }
  </div>
  <div class="right-sidebar">
    <section class="box-shadow">
      <h3>{{'SafetyAndPrevention.CheckWorkerEligibility' | translate}}</h3>
      <div class="text">{{'SafetyAndPrevention.CheckWorkerEligibilityText' | translate}}</div>
      <a [routerLink]="getUrl('/safety-and-prevention/eligibility-checker')">{{'SafetyAndPrevention.CheckEligibility' |
      translate}}</a>
    </section>

    @if (pagepath!='Employers') {
      <section class="box-shadow">
        <h3>{{'SafetyAndPrevention.FreeTrainingForWorkersAndEmployers' | translate}}</h3>
        <div class="text">{{'SafetyAndPrevention.FreeTrainingForWorkersAndEmployersText' | translate}}</div>
        <a routerLink="/safety-and-prevention/cpo-approved-courses">{{'SafetyAndPrevention.AccessFreeTraining' |
        translate}}</a>
      </section>
    }

    <section class="box-shadow">
      <h3>{{'SafetyAndPrevention.AreYouAware' | translate}}</h3>
      @if (pagepath!='TrainingProviders') {
        <div class="text">{{'SafetyAndPrevention.AreYouAwareText' | translate}}
        </div>
      }
      @if (pagepath=='TrainingProviders') {
        <div class="text">{{'SafetyAndPrevention.AreYouAwareTextTP' | translate}}
        </div>
      }
      <div class="list-links">
        @if (currentLang == 'en') {
          <a
            href="https://www.ontario.ca/page/worker-health-and-safety-awareness-four-steps#section-0" target="_blank"
          rel="noopener">{{'SafetyAndPrevention.AreYouAwareStep4Workers' | translate}}</a>
        }
        @if (currentLang == 'fr') {
          <a
            href="https://www.ontario.ca/fr/page/sensibilisation-des-travailleurs-la-sante-et-la-securite-au-travail-en-quatre-etapes#section-0"
          target="_blank" rel="noopener">{{'SafetyAndPrevention.AreYouAwareStep4Workers' | translate}}</a>
        }
        @if (currentLang == 'en') {
          <a
            href="https://www.ontario.ca/page/supervisor-health-and-safety-awareness-five-steps#section-0" target="_blank"
          rel="noopener">{{'SafetyAndPrevention.AreYouAwareSetp5Supervisors' | translate}}</a>
        }
        @if (currentLang == 'fr') {
          <a
            href="https://www.ontario.ca/fr/page/sensibilisation-des-superviseurs-la-sante-et-la-securite-au-travail-en-cinq-etapes#section-0"
          target="_blank" rel="noopener">{{'SafetyAndPrevention.AreYouAwareSetp5Supervisors' | translate}}</a>
        }
      </div>
    </section>

    @if (pagepath!='Employers') {
      <section class="box-shadow">
        <h3>{{'SafetyAndPrevention.FAQs' | translate}}</h3>
        <div class="list-links">
          <a [routerLink]="getUrl('/safety-and-prevention/faqs')" fragment="account">{{'SafetyAndPrevention.FAQ1Account' |
          translate}}</a>
          <a [routerLink]="getUrl('/safety-and-prevention/faqs')" fragment="password">{{'SafetyAndPrevention.FAQ2Password'
          | translate}}</a>
          <a [routerLink]="getUrl('/safety-and-prevention/faqs')"
          fragment="learnerlogin">{{'SafetyAndPrevention.FAQ3WorkerLogin' | translate}}</a>
          <a [routerLink]="getUrl('/safety-and-prevention/faqs')" fragment="tplogin">{{'SafetyAndPrevention.FAQ4TPLogin' |
          translate}}</a>
          <a [routerLink]="getUrl('/safety-and-prevention/faqs')" fragment="tpguide">
            {{'SafetyAndPrevention.FAQ5Guide' | translate}}
          </a>
          <a [routerLink]="getUrl('/safety-and-prevention/faqs')">
            {{'SafetyAndPrevention.FAQSeeAll' | translate}}
          </a>
        </div>
      </section>
    }

    <section class="box-shadow">
      <h3>{{'SafetyAndPrevention.ContactUs' | translate}}</h3>
      <div class="text" [innerHTML]="getHtml('SafetyAndPrevention.ContactUsText' | translate)"></div>
      <div class="list-links">
        <div><img src="assets/ontario-design-system/icons/svg/ontario-icon-email.svg" alt="email icon" /><a
        href="mailto:webohs@ontario.ca">webohs&#64;ontario.ca</a></div>
        <div><img src="assets/ontario-design-system/icons/svg/ontario-icon-phone.svg" alt="phone icon" />1-877-202-0008
        </div>
        <div><img src="assets/ontario-design-system/icons/svg/ontario-icon-tty.svg" alt="tty icon" />1-855-653-9260
        </div>
      </div>
    </section>
  </div>
</div>